<script>
    import * as animateScroll from "svelte-scrollto";
    import {onMount} from 'svelte';

    export let subSelection;

    onMount(async () => {
        if (subSelection == 0) animateScroll.scrollToTop();
        else animateScroll.scrollTo({element: '#about-section-' + subSelection, offset: -80});
    });

    let message;
    let loading = false;
    
    const hideAlert = () => {
        window.$(".close").parent().hide();
    }

    async function sendData() {

        const proxyurl = "";
        const url = 'https://plataforma.cvschile.cl/site/contact';
        
        let formData = new FormData();
        formData.append('name', window.$("#form-name").val());
        formData.append('email', window.$("#form-email").val());
        formData.append('issue', window.$("#form-issue").val());
        formData.append('message', window.$("#form-message").val());

        window.$("#form-box :input, #form-button").attr('disabled', 'disabled');
        loading = true; 

        const res = await fetch(proxyurl+url, {
			method: 'POST',
			body: formData
        });
        	
        const response = await res.json();

        loading = false; 
        window.$('#form-box :input, #form-button').removeAttr("disabled");
        window.$(".close").parent().show();

        if(response){
            window.$('#form-box').get(0).reset();
            message = 'Se ha enviado el correo exitosamente.';
        }else{
            message = 'Ha ocurrido un error al enviar los datos o no se han llenado todos los campos del formulario.'; 
        } 
    }

</script>

<div class="row">
    <div class="col-12" style="text-align: -webkit-center;">
        <h1 class="title-content">Contacto</h1>
        {#if loading}
        <div class="d-flex justify-content-center" style="">
            <div class="spinner-border" role="status" style="height: 100px;width: 100px;">
                <span class="sr-only">Loading...</span>
            </div>
        </div>
        {/if}
        {#if message}
            <div class="alert alert-primary" role="alert" style="margin-top:5vh;">
                {message}
                <button type="button" class="close" on:click={hideAlert}>
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
        {/if}

        <form id="form-box" class="form-box">
            <div class="form-group">
                <label class="text-content" for="form-name">Nombre completo</label>
                <input type="text" class="form-control text-content" id="form-name" placeholder="Ej. Juanito Perez" required>
            </div>
            <div class="form-group">
                <label class="text-content" for="form-email">Correo electronico</label>
                <input type="email" class="form-control text-content" id="form-email" placeholder="ejemplo@email.cl" required>
            </div>
            <div class="form-group">
                <label class="text-content" for="form-issue">Asunto</label>
                <input type="text" class="form-control text-content" id="form-issue" placeholder="Asunto" required>
            </div>
            <div class="form-group">
                <label class="text-content" for="form-text-area">Mensaje</label>
                <textarea class="form-control text-content" id="form-message" rows="3" required></textarea>
            </div>
            <div class="form-group">
                <button id="form-button" class="form-button" type="button" on:click={sendData}>Enviar</button>
            </div>
        </form>
    </div>
</div>

<style>
    .title-content{
        text-align: left;
        width: 40%;
        font-size: 40px;
        padding-top: 15px;
    }

    .form-box {
        margin-top: 5vh;
        border: 2px solid #93C126;
        border-radius: 5px;
        padding: 2vh 2vh 5vh 2vh;
        width: 40%;
    }

    .form-group {
        width: 100%;
    }

    .form-group label {
        float: left;
    }

    .text-content {
        margin: 0;
    }

    .form-box .form-button {
        float: right;
        background-color: #93C126;
        border: 2px solid white;
        border-radius: 10px;
        color: white;
        width: 150px;
    }

    .form-box .form-button:hover {
        background-color: white;
        border: 2px solid #93C126;
        color: #93C126;
    }

    @media (max-width: 1400px) {
        .form-box, .title-content {
            width: 90%;
        }
    }

    @media (max-height: 800px) {
        .form-box {
            padding-bottom: 8vh;
        }
    }

    @media (max-width: 450px) {
        .form-box {
            padding-bottom: 8vh;
        }
    }


</style>